import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { IndicatorStore } from '../../../stores/indicator/indicator.state';
import { Indicator } from '../../../models/indicator';
import { DataLayer } from '../../../models/data-layer';
import { IndicatorDataStore } from '../../../stores/indicatpr-data/indicator-data.state';
import { DropdownModule } from 'primeng/dropdown';
import { NgIf } from '@angular/common';
import { PrimeTemplate } from 'primeng/api';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-indicator-data-dropdown',
  standalone: true,
  imports: [DropdownModule, NgIf, PrimeTemplate, FormsModule],
  templateUrl: './indicator-data-dropdown.component.html',
  styleUrl: './indicator-data-dropdown.component.scss',
})
export class IndicatorDataDropdownComponent {
  readonly indicatorStore = inject(IndicatorStore);
  readonly dataStore = inject(IndicatorDataStore);

  @Input() items: Indicator[] = [];
  @Input() label = 'Indikator';
  @Input() name = 'indikator';
  @Input() selection: Indicator | null = null;
  @Input() layerId!: string;
  @Input() disabled = false;
  @Input() enableEmpty = false;
  @Output() selectionChange = new EventEmitter<Indicator>();

  touched = false;

  ngOnInit() {
    this.items = this.dataStore
      .filterByDataLayer(this.layerId)
      .map(item => {
        return this.indicatorStore.getById(item.indicator);
      })
      .filter(item => !!item);

    this.selection =
      this.selection || (this.enableEmpty ? null : this.items[0]);
  }

  protected onChange = (value: Indicator) => {
    setTimeout(() => {
      this.selectionChange.emit(value);
    }, 10);
  };

  private onTouched = () => {
    this.touched = false;
  };

  writeValue(value: any): void {
    this.selection = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
